import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/checkbox/style";
import _Checkbox from "antd/lib/checkbox";
import "antd/lib/divider/style";
import _Divider from "antd/lib/divider";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useMemo, useState } from 'react';
import signOutUser from 'utils/signOut';
import styles from 'components/data-management/TermsOfUseIntercept.module.css';
import { updateUserAttributes } from 'redux/actions/user';
import { useDispatch } from 'react-redux';
import { termsOfUseCognitoKey, institutionCognitoKey } from 'const';
import downloadTermsOfUse from 'utils/downloadTermsOfUse';
import IframeModal from 'utils/IframeModal';
var Text = _Typography.Text;
var TermsOfUseIntercept = function TermsOfUseIntercept(props) {
  var dispatch = useDispatch();
  var user = props.user;
  var _user$attributes = user.attributes,
    originalAgreedPrivacyPolicy = _user$attributes[termsOfUseCognitoKey],
    originalInstitution = _user$attributes[institutionCognitoKey];
  var _useState = useState(originalAgreedPrivacyPolicy),
    readPrivacyAndCookie = _useState[0],
    setReadPrivacyAndCookie = _useState[1];
  var _useState2 = useState(originalAgreedPrivacyPolicy),
    agreedTerms = _useState2[0],
    setAgreedTerms = _useState2[1];
  var _useState3 = useState(originalInstitution),
    institution = _useState3[0],
    setInstitution = _useState3[1];
  var _useState4 = useState(false),
    dataUseVisible = _useState4[0],
    setDataUseVisible = _useState4[1];
  var _useState5 = useState(null),
    dataUseBlob = _useState5[0],
    setDataUseBlob = _useState5[1];
  var institutionFilledIn = useMemo(function () {
    return institution && institution.length > 0;
  }, [institution]);
  return __jsx(_Modal, {
    title: "Consent to the Trailmaker terms of use:",
    open: true,
    centered: true,
    className: styles['ok-to-the-right-modal'],
    cancelText: "Sign out",
    cancelButtonProps: {
      danger: true
    },
    okButtonProps: {
      disabled: agreedTerms !== 'true' || readPrivacyAndCookie !== 'true' || !institutionFilledIn
    },
    closable: false,
    maskClosable: false,
    width: 700,
    onOk: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(updateUserAttributes(user, _defineProperty(_defineProperty({}, termsOfUseCognitoKey, agreedTerms), institutionCognitoKey, institution)));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    onCancel: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", signOutUser());
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))
  }, __jsx(_Space, {
    direction: "vertical"
  }, __jsx(Text, {
    strong: true
  }, "Welcome to Trailmaker!"), __jsx(Text, null, "Trailmaker is available for free to all academic researchers.", __jsx("br", null), __jsx("br", null), "If you are an industry researcher who is currently a Parse customer, Trailmaker is also available for free.", __jsx("br", null), __jsx("br", null), "If you are an industry researcher who is not currently a Parse customer, a limited free trial of Trailmaker is available.", ' ', __jsx("a", {
    href: "https://www.parsebiosciences.com/contact/"
  }, "Contact us"), ' ', "to arrange this."), __jsx(_Space, {
    align: "baseline",
    style: {
      marginTop: 10
    }
  }, __jsx(Text, null, __jsx("span", {
    style: {
      color: '#ff0000',
      marginRight: 0
    }
  }, "*"), "Institution/Company:"), __jsx(_Input, {
    style: {
      minWidth: 300
    },
    value: institution,
    onChange: function onChange(e) {
      setInstitution(e.target.value);
    }
  })), __jsx(_Divider, {
    style: {
      marginLeft: 0,
      paddingLeft: 0,
      marginTop: 15,
      marginBottom: 10
    }
  }), __jsx(_Space, {
    align: "baseline"
  }, __jsx(_Checkbox, {
    defaultChecked: readPrivacyAndCookie === 'true',
    onChange: function onChange(e) {
      return setReadPrivacyAndCookie(e.target.checked.toString());
    }
  }), __jsx(Text, null, __jsx("span", {
    style: {
      color: '#ff0000'
    }
  }, "*"), "I confirm I have read the", ' ', __jsx(_Button, {
    type: "link",
    style: {
      padding: '0px'
    },
    onClick: function onClick() {
      return window.open('https://www.parsebiosciences.com/privacy-policy/', '_blank').focus();
    }
  }, "Privacy policy"), ' and ', __jsx(_Button, {
    type: "link",
    style: {
      padding: '0px'
    },
    onClick: function onClick() {
      return window.open('https://www.parsebiosciences.com/trailmaker-cookie-policy/', '_blank').focus();
    }
  }, "Trailmaker Cookie Policy"), ".")), __jsx(_Space, {
    align: "baseline"
  }, __jsx(_Checkbox, {
    defaultChecked: agreedTerms === 'true',
    onChange: function onChange(e) {
      return setAgreedTerms(e.target.checked.toString());
    }
  }), __jsx(Text, null, __jsx("span", {
    style: {
      color: '#ff0000'
    }
  }, "*"), "I accept the", ' ', __jsx(_Button, {
    type: "link",
    style: {
      padding: '0px'
    },
    onClick: function onClick() {
      setDataUseVisible(true);
      if (!dataUseBlob) {
        downloadTermsOfUse(setDataUseBlob);
      }
    }
  }, "Terms of Use Agreement")))), dataUseVisible && __jsx(IframeModal, {
    onClose: function onClose() {
      return setDataUseVisible(false);
    },
    blobToDisplay: dataUseBlob
  }));
};
TermsOfUseIntercept.defaultProps = {};
export default TermsOfUseIntercept;